import { ajax } from '@/utils/request';
const api = {
    // 获取开票列表
    getBillingList(data:any){
        return ajax({
            method: 'get',
            url: `invoice-mgt/invoice`,
            data
        })
    },
    // 获取开票列表
    getBillingCount(){
        return ajax({
            method: 'get',
            url: `invoice-mgt/invoice-count`,

        })
    },
    // 获取员工tree
    getEmployeesTree(){
        return ajax({
            method: 'post',
            url: `sys-employee-mgt/employees/tree`,

        })
    },
    // 获取进行中的项目
    getProjectListIng(data:any){
        return ajax({
            method: 'get',
            url: `project-mgt/projects`,
            data

        })
    },
    // 获取客户列表的项目
    getCustomerListIng(data:any){
        return ajax({
            method: 'get',
            url: `customer-mgt/select-customer-list`,
            data

        })
    },
    // 获取客户列表的项目
    createInvoice(data:any){
        return ajax({
            method: 'post',
            url: `invoice-mgt/invoice`,
            data

        })
    },
    // 获取开票申请详情
    getInvoiceInfo(id:any){
        return ajax({
            method: 'get',
            url: `invoice-mgt/invoice/${id}`,
        })
    },
    // 审核通过
    setTaskComplete(data:any){
        return ajax({
            method: 'post',
            url: `process-task-mgt/complete`,
            data
        })
    },
    // 审核拒绝
    setTaskRejected(data:any){
        return ajax({
            method: 'post',
            url: `process-task-mgt/rejected`,
            data
        })
    },
    // 获取上次审核人
    getLastProcessPerson(data:any){
        return ajax({
            method: 'get',
            url: `process/last-approver/${data.processDefinitionId}`,
            data
        })
    },
    // 办公用品领用退回发起人
    backToStartOfficeUse(data:any){
        return ajax({
            method: 'put',
            url: `office-use-mgt/back-start/${data.id}`,
            data
        })
    },
    // 办公用品采购退回发起人
    backToStartOfficePurchase(data:any){
        return ajax({
            method: 'put',
            url: `office-purchase-mgt/back-start/${data.id}`,
            data
        })
    },
    // 通用退回发起人
    backToStartCommon(data:any){
        return ajax({
            method: 'put',
            url: `common-flow-mgt/back-start/${data.id}`,
            data
        })
    },
    // 出差退回发起人
    backToStartTravel(data:any){
        return ajax({
            method: 'put',
            url: `travel-mgt/back-start/${data.id}`,
            data
        })
    },
    // 请假退回发起人
    backToStartLeavel(data:any){
        return ajax({
            method: 'put',
            url: `leave-mgt/back-start/${data.id}`,
            data
        })
    },
    // 报销退回发起人
    backToStartReimbursement(data:any){
        return ajax({
            method: 'put',
            url: `reimbursement-mgt/back-start/${data.id}`,
            data
        })
    },
    // 用章退回发起人
    backToStartSeal(data:any){
        return ajax({
            method: 'put',
            url: `seal-mgt/back-start/${data.id}`,
            data
        })
    },
    // 借款退回发起人
    backToStartBorrowing(data:any){
        return ajax({
            method: 'put',
            url: `borrowing-mgt/back-start/${data.id}`,
            data
        })
    },
    // 材料询价退回发起人
    backToStartInquiry(data:any){
        return ajax({
            method: 'put',
            url: `inquiry-mgt/back-start/${data.id}`,
            data
        })
    },
    // 奖惩退回发起人
    backToStartReward(data:any){
        return ajax({
            method: 'put',
            url: `reward-punishments-mgt/back-start/${data.id}`,
            data
        })
    },
    // 开票申请退回发起人
    backToStartInvoice(data:any){
        return ajax({
            method: 'put',
            url: `invoice-mgt/back-start/${data.id}`,
            data
        })
    },
    // 材料总计划退回发起人
    backToStartTotalMaterialPlan(data:any){
        return ajax({
            method: 'put',
            url: `material-total-plan-mgt/back-start/${data.id}`,
            data
        })
    },
    // 材料分批计划退回发起人
    backToStartSubMaterialPlan(data:any){
        return ajax({
            method: 'put',
            url: `material-sub-plan-mgt/back-start/${data.id}`,
            data
        })
    },
    // 采购退回发起人
    backToStartPurchase(data:any){
        return ajax({
            method: 'put',
            url: `purchase-mgt/back-start/${data.id}`,
            data
        })
    },
    // 合同退回发起人
    backToStartContract(data:any){
        return ajax({
            method: 'put',
            url: `contract-apply/back-start/${data.id}`,
            data
        })
    },
    // 付款退回发起人
    backToStartPayment(data:any){
        return ajax({
            method: 'put',
            url: `payment-mgt/back-start/${data.id}`,
            data
        })
    },
    // 退回上一审核人
    backPrevTask(data:any){
        return ajax({
            method: 'post',
            url: `process-task-mgt/backPrev`,
            data
        })
    },
    // 审核拒绝
    setSealRejected(data:any,id:any){
        return ajax({
            method: 'put',
            url: `seal-mgt/${id}/reject`,
            data
        })
    },
    // 审核拒绝
    setRewardPunishmentsReject(data:any){
        return ajax({
            method: 'put',
            url: `reward-punishments-mgt/${data.id}/reject`,
            data
        })
    },
    // 开票退回
    setBillingBack(id:any){
        return ajax({
            method: 'put',
            url: `invoice-mgt/withdraw/${id}`
        })
    },
    // 开票作废
    setBillingInvalid(id:any){
        return ajax({
            method: 'put',
            url: `invoice-mgt/invalid/${id}`
        })
    },
    // 开票导出
    exportBilling(data:any){
        return ajax({
            method: 'get',
            url: `invoice-mgt/export-invoice-list`,
            data: data,
            headers: {},
            type: "blob"
        })
    },
    // 请假导出
    exportLeave(data:any){
        return ajax({
            method: 'get',
            url: `leave-mgt/export`,
            data: data,
            headers: {},
            type: "blob"
        })
    },
    // 出差导出
    exportTravel(data:any){
        return ajax({
            method: 'get',
            url: `travel-mgt/export`,
            data: data,
            headers: {},
            type: "blob"
        })
    },
    // 通用流程导出
    exportCommonFlow(data:any){
        return ajax({
            method: 'get',
            url: `common-flow-mgt/export`,
            data: data,
            headers: {},
            type: "blob"
        })
    },
    // 办公用品领用导出
    exportOfficeUse(data:any){
        return ajax({
            method: 'get',
            url: `office-use-mgt/export`,
            data: data,
            headers: {},
            type: "blob"
        })
    },
    // 办公用品采购导出
    exportPurchase(data:any){
        return ajax({
            method: 'get',
            url: `office-purchase-mgt/export`,
            data: data,
            headers: {},
            type: "blob"
        })
    },
    // 工作周报导出
    exportWeeklyList(data:any){
        return ajax({
            method: 'get',
            url: `work-mgt/export`,
            data: data,
            headers: {},
            type: "blob"
        })
    },
    //下载开票申请
    exportBillingIn(id:any) {
        return ajax({
            method: 'get',
            url: `invoice-mgt/export-invoice/${id}`,
            headers: {},
            type: "blob"
        });
    },
    //下载用章申请
    exportSealIn(id:any) {
        return ajax({
            method: 'get',
            url: `seal-mgt/export/${id}`,
            headers: {},
            type: "blob"
        });
    },
    //下载工作周报
    exportWeeklyInfo(id:any) {
        return ajax({
            method: 'get',
            url: `work-mgt/export-work/${id}`,
            headers: {},
            type: "blob"
        });
    },
    exportReward(id:any) {
        return ajax({
            method: 'get',
            url: `reward-punishments-mgt/export/${id}`,
            headers: {},
            type: "blob"
        });
    },
    //工作周报
    getWorkWeeklyList(data:any) {
        return ajax({
            method: 'get',
            url: `work-mgt/work`,
            data
        });
    },
    // 周报统计
    weeklySum(){
        return ajax({
            method: 'get',
            url: `work-mgt/weekly-sum`,
        });
    },
    // 新增批阅信息
    addWeeklyReivew(data:any){
        return ajax({
            method: 'post',
            url: `work-mgt/work/review`,
            data: data
        });
    },
    // 撤回工作周报
    withDrawWeekly(id:any){
        return ajax({
            method: 'put',
            url: `work-mgt/withdraw/${id}`
        });
    },
    //部门
    getDeptsLists() {
        return ajax({
            method: 'get',
            url: `dept-mgt/depts`,
        });
    },
    //新增周报
    createWeekly(data:any) {
        return ajax({
            method: 'post',
            url: `work-mgt/work`,
            data
        });
    },
    //新增周报
    upDateWeekly(data:any,id:any) {
        return ajax({
            method: 'put',
            url: `work-mgt/work/${id}`,
            data
        });
    },
    //新增周报
    getWeeklyInfo(id:any) {
        return ajax({
            method: 'get',
            url: `work-mgt/work/${id}`,
        });
    },
    //项目变更列表
    getProjectChangeList(data:any) {
        return ajax({
            method: 'get',
            url: `project-change-mgt/project-change`,
            data
        });
    },
    //新增项目变更
    addProjectChange(data:any) {
        return ajax({
            method: 'post',
            url: `project-change-mgt/project-change`,
            data
        });
    },
    //项目变更统计
    projectChangeCount(data:any){
        return ajax({
            method: 'get',
            url: `project-change-mgt/sum`,
            data
        });
    },
    //项目变更导出
    projectChangeExport(data:any){
        return ajax({
            method: 'get',
            url: `project-change-mgt/export`,
            data,
            type: "blob"
        });
    },
    //新增项目变更
    updateProjectChange(data:any,id:any) {
        return ajax({
            method: 'put',
            url: `project-change-mgt/project-change/${id}`,
            data
        });
    },
    //获取项目变更
    getProjectChangeInfo(id:any) {
        return ajax({
            method: 'get',
            url: `project-change-mgt/project-change/${id}`,
        });
    },
    //移除项目变更
    delProjectChangeList(id:any) {
        return ajax({
            method: 'delete',
            url: `project-change-mgt/project-change/${id}`,
        });
    },
    //施工日志
    getProjectLogList(data:any) {
        return ajax({
            method: 'get',
            url: `construction-mgt/construction`,
            data
        });
    },
    //施工日志
    createProjectLog(data:any) {
        return ajax({
            method: 'post',
            url: `construction-mgt/construction`,
            data
        });
    },
    //施工日志
    getProjectLogInfo(id:any) {
        return ajax({
            method: 'get',
            url: `construction-mgt/construction/${id}`,
        });
    },
    //施工日志
    upDateProjectLog(data:any,id:any) {
        return ajax({
            method: 'put',
            url: `construction-mgt/construction/${id}`,
            data
        });
    },
    //获取最后一次提交工作计划
    getLastWeeklyInfo() {
        return ajax({
            method: 'get',
            url: `work-mgt/last-weekly-report`,
        });
    },
    //获取安全技术交底
    safeTechnologyList(data:any) {
        return ajax({
            method: 'get',
            url: `safe-technology-mgt/technology`,
            data
        });
    },
    //获取班组工人
    getLaboursList(data:any) {
        return ajax({
            method: 'get',
            url: `labour-class-member/list`,
            data
        });
    },
    //获取班组工人
    createSafeTechnology(data:any) {
        return ajax({
            method: 'post',
            url: `safe-technology-mgt/technology`,
            data
        });
    },
    //获取
    getSafeTechnologyInfo(id:any) {
        return ajax({
            method: 'get',
            url: `safe-technology-mgt/technology/${id}`,
        });
    },
    //获取
    upDateSafeTechnology(data:any,id:any) {
        return ajax({
            method: 'put',
            url: `safe-technology-mgt/technology/${id}`,
            data
        });
    },
    //移除
    delSafeTechnologyList(id:any) {
        return ajax({
            method: 'delete',
            url: `safe-technology-mgt/technology/${id}`
        });
    },
    //三级教育
    safeEducationList(data:any) {
        return ajax({
            method: 'get',
            url: `safe-education-mgt/education`,
            data
        });
    },
    //三级教育
    createSafeEducation(data:any) {
        return ajax({
            method: 'post',
            url: `safe-education-mgt/education`,
            data
        });
    },
    //三级教育
    upDateSafeEducation(data:any,id:any) {
        return ajax({
            method: 'put',
            url: `safe-education-mgt/education/${id}`,
            data
        });
    },
    //三级教育
    getSafeEducationInfo(id:any) {
        return ajax({
            method: 'get',
            url: `safe-education-mgt/education/${id}`,
        });
    },
    //三级教育
    delSafeEducationInfo(id:any) {
        return ajax({
            method: 'delete',
            url: `safe-education-mgt/education/${id}`,
        });
    },
    //安全会议
    safeMeetingList(data:any) {
        return ajax({
            method: 'get',
            url: `safe-meeting-mgt/meeting`,
            data
        });
    },
    //安全会议
    createSafeMeeting(data:any) {
        return ajax({
            method: 'post',
            url: `safe-meeting-mgt/meeting`,
            data
        });
    },
    //安全会议
    getSafeMeetingInfo(id:any) {
        return ajax({
            method: 'get',
            url: `safe-meeting-mgt/meeting/${id}`,
        });
    },
    //安全会议
    upDateSafeMeeting(data:any,id:any) {
        return ajax({
            method: 'put',
            url: `safe-meeting-mgt/meeting/${id}`,
            data
        });
    },
    //安全日志
    safeLogList(data:any) {
        return ajax({
            method: 'get',
            url: `safe-log-mgt/log`,
            data
        });
    },
    //安全日志
    createSafeLog(data:any) {
        return ajax({
            method: 'post',
            url: `safe-log-mgt/log`,
            data
        });
    },
    //安全日志
    getSafeLogInfo(id:any) {
        return ajax({
            method: 'get',
            url: `safe-log-mgt/log/${id}`,
        });
    },
    //安全日志
    upDateSafeLog(data:any,id:any) {
        return ajax({
            method: 'put',
            url: `safe-log-mgt/log/${id}`,
            data
        });
    },
    //安全日志
    delSafeLogInfo(id:any) {
        return ajax({
            method: 'delete',
            url: `safe-log-mgt/log/${id}`,
        });
    },
    //强管节点
    getStrongNodeList(data:any) {
        return ajax({
            method: 'get',
            url: `strong-node-check-mgt/check`,
            data
        });
    },
    //强管节点
    getStrongNodeCheckList() {
        return ajax({
            method: 'get',
            url: `strong-node-check-config-mgt/list`,
        });
    },
    // 强管节点带状态列表
    getStrongWithStateNodeCheckList(data:any){
        return ajax({
            method: 'get',
            url: `strong-node-check-mgt/config-list`,
            data: data
        });
    },
    //强管节点
    createStrongNodeManage(data:any) {
        return ajax({
            method: 'post',
            url: `strong-node-check-mgt/check`,
            data
        });
    },
    //强管节点
    getStrongNodeInfo(id:any) {
        return ajax({
            method: 'get',
            url: `strong-node-check-mgt/check/${id}`,
        });
    },
    //强管节点
    upDateStrongNodeManage(data:any,id:any) {
        return ajax({
            method: 'put',
            url: `strong-node-check-mgt/check/${id}`,
            data
        });
    },
    //户型图
    getDiagramList(data:any) {
        return ajax({
            method: 'get',
            url: `diagram-mgt/diagram`,
            data
        });
    },
    //户型图
    createDiagramManage(data:any) {
        return ajax({
            method: 'post',
            url: `diagram-mgt/diagram`,
            data
        });
    },
    //户型图
    getDiagramManageInfo(id:any) {
        return ajax({
            method: 'get',
            url: `diagram-mgt/diagram/${id}`,
        });
    },
    //户型图
    upDateDiagramManage(data:any,id:any) {
        return ajax({
            method: 'put',
            url: `diagram-mgt/diagram/${id}`,
            data
        });
    },
    //实测实量任务
    getMeasureTaskList(data:any) {
        return ajax({
            method: 'get',
            url: `measure-task-mgt/measure`,
            data
        });
    },
    //实测实量任务
    getDiagramManageLists(data:any) {
        return ajax({
            method: 'get',
            url: `diagram-mgt/list`,
            data
        });
    },
    //模板列表
    getTemplateLists(data:any) {
        return ajax({
            method: 'get',
            url: `inspect-template-mgt/template`,
            data
        });
    },
    //模板列表
    createTemplateInfo(data:any) {
        return ajax({
            method: 'post',
            url: `inspect-template-mgt/template`,
            data
        });
    },
    //模板列表
    getTemplateInfo(id:any) {
        return ajax({
            method: 'get',
            url: `inspect-template-mgt/template/${id}`,
        });
    },
    //模板列表
    upDateTemplateInfo(data:any,id:any) {
        return ajax({
            method: 'put',
            url: `inspect-template-mgt/template/${id}`,
            data
        });
    },
    //模板列表
    getInspectContentList(data:any) {
        return ajax({
            method: 'get',
            url: `inspect-content-mgt/content`,
            data
        });
    },
    //模板列表
    getInspectTemplateList() {
        return ajax({
            method: 'get',
            url: `inspect-template-mgt/list`,
        });
    },
    //模板列表
    createInspectContentInfo(data:any) {
        return ajax({
            method: 'post',
            url: `inspect-content-mgt/content`,
            data
        });
    },
    //模板列表
    getInspectContentInfo(id:any) {
        return ajax({
            method: 'get',
            url: `inspect-content-mgt/content/${id}`,
        });
    },
    //模板列表
    upDateInspectContentInfo(data:any,id:any) {
        return ajax({
            method: 'put',
            url: `inspect-content-mgt/content/${id}`,
            data
        });
    },
    //用章
    getSealManageList(data:any) {
        return ajax({
            method: 'get',
            url: `seal-mgt/seal`,
            data
        });
    }, 
    //用章
    getSealListCount(data:any) {
        return ajax({
            method: 'get',
            url: `seal-mgt/seal-sum`,
            data
        });
    },
    //用章
    createSealManageInfo(data:any) {
        return ajax({
            method: 'post',
            url: `seal-mgt/seal`,
            data
        });
    },
    //用章
    upDateSealManageInfo(data:any,id:any) {
        return ajax({
            method: 'put',
            url: `seal-mgt/seal/${id}`,
            data
        });
    },
    //用章
    getSealMgtInfo(id:any) {
        return ajax({
            method: 'get',
            url: `seal-mgt/seal/${id}`,
        });
    },
    // 审核通过
    setSealComplete(data:any,id:any){
        return ajax({
            method: 'post',
            url: `seal-mgt/${id}//complete`,
            data
        })
    },
    // 修改开票申请
    upDateInvoiceMgtInfo(data:any,id:any){
        return ajax({
            method: 'put',
            url: `invoice-mgt/invoice/${id}`,
            data
        })
    },
    // 申请退回
    setSealBack(id:any){
        return ajax({
            method: 'put',
            url: `seal-mgt/${id}/back`,
        })
    },
    // 申请废弃
    setSealInvalid(id:any){
        return ajax({
            method: 'put',
            url: `seal-mgt/${id}/cancel`,
        })
    },
    // 申请导出
    exportSeal(data:any){
        return ajax({
            method: 'get',
            url: `seal-mgt/export`,
            data: data,
            headers: {},
            type: "blob"
        })
    },
    // 奖惩
    rewardPunishmentsList(data:any){
        return ajax({
            method: 'get',
            url: `reward-punishments-mgt/reward-punishments`,
            data: data,
        })
    },
    // 新增奖惩
    createRewardPunishments(data:any){
        return ajax({
            method: 'post',
            url: `reward-punishments-mgt/reward-punishments`,
            data: data,
        })
    },
    // 奖惩
    getrewardPunishmentsInfo(id:any){
        return ajax({
            method: 'get',
            url: `reward-punishments-mgt/reward-punishments/${id}`,
        })
    },
    // 奖惩
    upDateRewardPunishments(data:any,id:any){
        return ajax({
            method: 'put',
            url: `reward-punishments-mgt/reward-punishments/${id}`,
            data
        })
    },
    // 
    // 奖惩-列表数据统计
    rewardPunishmentsCount(data:any){
        return ajax({
            method: 'get',
            url: `reward-punishments-mgt/reward-punishments-sum`,
            data: data,
        })
    },
    // 奖惩-退回
    rewardPunishmentsBack(id:any){
        return ajax({
            method: 'put',
            url: `reward-punishments-mgt/${id}/back`,
        })
    },
    // 奖惩-作废
    rewardPunishmentsCancel(id:any){
        return ajax({
            method: 'put',
            url: `reward-punishments-mgt/${id}/cancel`,
        })
    },
    // 奖惩-导出列表
    rewardPunishmentsListExport(data:any){
        return ajax({
            method: 'get',
            url: `reward-punishments-mgt/export`,
            data: data,
            type: 'blob'
        })
    },

    // 移除周报
    delWeekly(id:any){
        return ajax({
            method: 'delete',
            url: `work-mgt/work/${id}`,
        })
    },
    // 移除安全会议
    delSafeMeetingInfo(id:any){
        return ajax({
            method: 'delete',
            url: `safe-meeting-mgt/meeting/${id}`,
        })
    },
    // 移除施工日志
    delProjectLogList(id:any){
        return ajax({
            method: 'delete',
            url: `construction-mgt/construction/${id}`,
        })
    },
    // 甲方收款台账分页
    financePayeeList(data:any){
        return ajax({
            method: 'get',
            url: `finance-mgt/receive-payment`,
            data
        })
    },
    // 甲方收款台账统计
    financePayeeCount(data:any){
        return ajax({
            method: 'get',
            url: `finance-mgt/${data.projectId}/receive-payment-count`,
        })
    },
    // 甲方收款台账统计
    createFinancePayment(data:any){
        return ajax({
            method: 'post',
            url: `finance-mgt/receive-payment`,
            data
        })
    },
    // 甲方收款台账统计
    editFinancePayment(data:any,id:any){
        return ajax({
            method: 'put',
            url: `finance-mgt/receive-payment/${id}`,
            data
        })
    },
    //获取甲方收款台账
    getFinancePaymentInfo(id:any){
        return ajax({
            method: 'get',
            url: `finance-mgt/receive-payment/${id}`,
        })
    },
    //获取甲方收款台账
    delFinancePayment(id:any){
        return ajax({
            method: 'delete',
            url: `finance-mgt/receive-payment/${id}`,
        })
    },
    //获取甲方收款台账
    secondBillList(data:any){
        return ajax({
            method: 'get',
            url: `second-bill-mgt/second-bill`,
            data
        })
    },
    //其他支出台账
    otherSpendingList(data:any){
        return ajax({
            method: 'get',
            url: `bill-mgt/other-spending`,
            data
        })
    },
    //劳务支出成本
    labourSpendingList(id:any){
        return ajax({
            method: 'get',
            url: `bill-mgt/labour-spending/${id}`,
        })
    },
    //双包材料支出成本
    doubleMaterialSpendingList(data:any,id:any){
        return ajax({
            method: 'get',
            url: `bill-mgt/double-and-material-spending/${id}`,
            data
        })
    },
    //借款确认
    borrowingConfirm(id:any){
        return ajax({
            method: 'put',
            url: `borrowing-mgt/${id}/confirm`,
        })
    },
    //确认收款
    financeConfirmReceipt(data:any){
        return ajax({
            method: 'put',
            url: `finance-mgt/confirm-receipt/${data.id}/${data.actualReceivedAmount}?payWay=${data.payWay}`,
        })
    }, 
    //确认收款
    financeConfirmExport(data:any){
        return ajax({
            method: 'get',
            url: `finance-mgt/confirm-receipt/export`,
            data,
            headers: {},
            type: "blob"
        })
    },
    //请假申请分页
    getLeaveList(data:any){
        return ajax({
            method: 'get',
            url: `leave-mgt/leave`,
            data
        })
    },
    //请假列表统计
    getLeaveSum(){
        return ajax({
            method: 'get',
            url: `leave-mgt/leave-sum`
        })
    },
    //请假列表统计
    createLeaveMassage(data:any){
        return ajax({
            method: 'post',
            url: `leave-mgt/leave`,
            data
        })
    },
    //获取请假申请
    getLeaveInfo(id:any){
        return ajax({
            method: 'get',
            url: `leave-mgt/leave/${id}`,
        })
    },
    //修改请假申请
    upDateLeaveMassage(data:any,id:any){
        return ajax({
            method: 'put',
            url: `leave-mgt/leave/${id}`,
            data
        })
    },
    //出差列表统计
    getTravelSum(){
        return ajax({
            method: 'get',
            url: `travel-mgt/travel-sum`,
        })
    },
    //出差申请分页
    getTravelList(data:any){
        return ajax({
            method: 'get',
            url: `travel-mgt/travel`,
            data
        })
    },
    //修改出差申请
    upDateTravelMassage(data:any,id:any){
        return ajax({
            method: 'put',
            url: `travel-mgt/travel/${id}`,
            data
        })
    },
    //新增出差申请
    createTravelMassage(data:any){
        return ajax({
            method: 'post',
            url: `travel-mgt/travel`,
            data
        })
    },
    //新增出差申请
    getTravelInfo(id:any){
        return ajax({
            method: 'get',
            url: `travel-mgt/travel/${id}`,
        })
    },
    //请假申请审核不通过
    setLeaveRejected(data:any,id:any){
        return ajax({
            method: 'put',
            url: `leave-mgt/${id}/reject`,
            data
        })
    },
    //出差申请审核不通过
    setTravelRejected(data:any,id:any){
        return ajax({
            method: 'put',
            url: `travel-mgt/${id}/reject`,
            data
        })
    },
    //通用流程申请审核不通过
    setCommonFlowRejected(data:any,id:any){
        return ajax({
            method: 'put',
            url: `common-flow-mgt/${id}/reject`,
            data
        })
    },
    //请假申请退回
    setLeaveBack(id:any){
        return ajax({
            method: 'put',
            url: `leave-mgt/${id}/back`
        })
    },
    //请假申请作废
    setLeaveInvalid(id:any){
        return ajax({
            method: 'put',
            url: `leave-mgt/${id}/cancel`
        })
    }, 
    //请假申请退回
    setTravelBack(id:any){
        return ajax({
            method: 'put',
            url: `travel-mgt/${id}/back`
        })
    },
    //请假申请作废
    setTravelInvalid(id:any){
        return ajax({
            method: 'put',
            url: `travel-mgt/${id}/cancel`
        })
    },
    //通用流程申请退回
    setCommonFlowBack(id:any){
        return ajax({
            method: 'put',
            url: `common-flow-mgt/${id}/back`
        })
    },
    //通用流程申请作废
    setCommonFlowInvalid(id:any){
        return ajax({
            method: 'put',
            url: `common-flow-mgt/${id}/cancel`
        })
    },
    //通用流程申请分页
    getCommonFlowList(data:any){
        return ajax({
            method: 'get',
            url: `common-flow-mgt/flow`,
            data
        })
    },
    //通用流程列表统计
    getCommonFlowSum(){
        return ajax({
            method: 'get',
            url: `common-flow-mgt/flow-sum`,
        })
    },
    //修改通用流程申请
    upDateCommonFlowMassage(data:any,id:any){
        return ajax({
            method: 'put',
            url: `common-flow-mgt/flow/${id}`,
            data
        })
    },
    //获取通用流程申请
    getCommonFlowInfo(id:any){
        return ajax({
            method: 'get',
            url: `common-flow-mgt/flow/${id}`,
        })
    },
    //新增通用流程申请
    createCommonFlowMassage(data:any){
        return ajax({
            method: 'post',
            url: `common-flow-mgt/flow`,
            data
        })
    },
    //办公用品领用申请统计
    getOfficeUseCount(){
        return ajax({
            method: 'get',
            url: `office-use-mgt/office-sum`,
        })
    },
    //办公用品领用申请分页
    getOfficeUseList(data:any){
        return ajax({
            method: 'get',
            url: `office-use-mgt/office`,
            data
        })
    },
    //新增办公用品领用申请
    createOfficeUse(data:any){
        return ajax({
            method: 'post',
            url: `office-use-mgt/office`,
            data
        })
    },
    //获取办公用品领用申请
    getOfficeUseInfo(id:any){
        return ajax({
            method: 'get',
            url: `office-use-mgt/office/${id}`
        })
    },
    //修改办公用品领用申请
    updateOfficeUse(data:any,id:any){
        return ajax({
            method: 'put',
            url: `office-use-mgt/office/${id}`,
            data
        })
    },
    //办公用品领用审核不通过
    setOfficeUseRejected(data:any,id:any){
        return ajax({
            method: 'put',
            url: `office-use-mgt/${id}/reject`,
            data
        })
    },
    //办公用品领用退回
    setOfficeUseBack(id:any){
        return ajax({
            method: 'put',
            url: `office-use-mgt/${id}/back`,
        })
    },
    //办公用品领用作废
    setOfficeUseInvalid(id:any){
        return ajax({
            method: 'put',
            url: `office-use-mgt/${id}/cancel`,
        })
    },
    //办公用品采购退回
    setOfficePurchaseBack(id:any){
        return ajax({
            method: 'put',
            url: `office-purchase-mgt/${id}/back`,
        })
    },
    //办公用品采购作废
    setOfficePurchaseInvalid(id:any){
        return ajax({
            method: 'put',
            url: `office-purchase-mgt/${id}/cancel`,
        })
    }, 
    //办公用品采购列表统计
    getOfficePurchaseCount(){
        return ajax({
            method: 'get',
            url: `office-purchase-mgt/office-sum`,
        })
    },
    //未读消息数
    getMessageCount(){
        return ajax({
            method: 'get',
            url: `message-mgt/un-read-count`,
        })
    },
    //消息分页
    getNewsList(data:any){
        return ajax({
            method: 'get',
            url: `message-mgt/message`,
            data
        })
    },
    // 消息详情
    getNewsDetail(id:any){
        return ajax({
            method: 'get',
            url: `message-mgt/message/${id}`,
        })
    },
    //请假申请导出pdf
    exportLeavePdf(id:any) {
        return ajax({
            method: 'get',
            url: `leave-mgt/export/${id}`,
            headers: {},
            type: "blob"
        });
    },
    //出差申请导出pdf
    exportTravelPdf(id:any) {
        return ajax({
            method: 'get',
            url: `travel-mgt/export/${id}`,
            headers: {},
            type: "blob"
        });
    },
    //通用流程导出pdf
    exportCommonFlowPdf(id:any) {
        return ajax({
            method: 'get',
            url: `common-flow-mgt/export/${id}`,
            headers: {},
            type: "blob"
        });
    },
    //办公用品采购导出pdf
    exportOfficePurchasePdf(id:any) {
        return ajax({
            method: 'get',
            url: `office-purchase-mgt/export/${id}`,
            headers: {},
            type: "blob"
        });
    },
    //办公用品领用导出pdf
    exportOfficeUsePdf(id:any) {
        return ajax({
            method: 'get',
            url: `office-use-mgt/export/${id}`,
            headers: {},
            type: "blob"
        });
    },
    //全部标为已读
    setReadAll() {
        return ajax({
            method: 'put',
            url: `message-mgt/read-all`,
        });
    },
    //统计
    getWeeklyCount() {
        return ajax({
            method: 'get',
            url: `work-mgt/weekly-sum`,
        });
    },
    //统计
    weekReview(data:any) {
        return ajax({
            method: 'post',
            url: `work-mgt/work/review`,
            data
        });
    },
    dowOfficeMgt(data:any) {
        return ajax({
            method: 'get',
            url: `office-stock-mgt/assets/export`,
            type: "blob",
            data
        });
    },
}

export default api;